// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '../App'
import routes from './route'
import VueRouter from 'vue-router'
import i18n from '../../i18n'
import VueProgrammaticInvisibleGoogleRecaptcha from 'vue-programmatic-invisible-google-recaptcha'
import VueClipboard from 'vue-clipboard2'
Vue.config.productionTip = false
/* eslint-disable no-new */
Vue.component('vue-programmatic-invisible-google-recaptcha', VueProgrammaticInvisibleGoogleRecaptcha)
Vue.use(VueRouter)
Vue.use(VueClipboard)
const router = new VueRouter({
  mode: 'history',
  routes
})

new Vue({
  el: '#app',
  router,
  render: h => h(App),
  i18n
})



// WEBPACK FOOTER //
// ./src/pages/index/index.js